export default "__VITE_ASSET__BxeU3w$y__"